// src/components/MessageInput.tsx
import React, { useState, useCallback } from "react";
import { ReadyState } from "react-use-websocket";
import { useUsername } from "../hooks/use-username";

interface MessageInputProps {
  sendMessage: (message: string) => void;
  readyState: ReadyState;
  isSidebar?: boolean;
}

export function MessageInput({
  sendMessage,
  readyState,
  isSidebar = false,
}: MessageInputProps) {
  const [username] = useUsername();
  const [messageInput, setMessageInput] = useState("");

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMessageInput(e.target.value);
  };

  const handleSend = useCallback(() => {
    if (messageInput.trim()) {
      sendMessage(messageInput.trim());
      setMessageInput("");
    }
  }, [messageInput, sendMessage]);

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSend();
    }
  };

  const isOpen = readyState === ReadyState.OPEN;

  return (
    <div className="flex items-center gap-3">
      <input
        type="text"
        value={messageInput}
        onChange={handleInputChange}
        onKeyPress={handleKeyPress}
        placeholder="Type a message..."
        maxLength={140 - username.length}
        enterKeyHint="send"
        className={`flex-grow rounded-lg border border-slate-300 px-4 py-2 text-slate-700 placeholder-slate-400 transition duration-150 ease-in-out focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/50`}
        disabled={!isOpen}
      />
      <button
        onClick={handleSend}
        className={`flex-shrink-0 rounded-lg bg-indigo-600 px-4 text-white transition duration-150 ease-in-out hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${
          isSidebar ? "py-2 text-xs" : "py-2.5 text-sm font-medium"
        }`}
        disabled={!isOpen || !messageInput.trim()}
      >
        Send
      </button>
    </div>
  );
}
